import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FrameworkAgreement } from './SupplierFrameworkAgreement';
import {
    SupplierFrameworkAgreementDialogComponent,
    SupplierFrameworkAgreementDialogData,
} from './demand-supplier-framework-agreement-dialog/demand-supplier-framework-agreement-dialog';
import { DialogOptions } from '@iim-angular/components';

@Injectable({
    providedIn: 'root',
})
export class FrameworkAgreementService {
    private readonly dialog = inject(MatDialog);

    public selectFrameworkAgreement(
        supplierCompanyId: string,
        editable = false,
        options: FrameworkAgreement[],
    ): Observable<FrameworkAgreement | void> {
        const data: SupplierFrameworkAgreementDialogData = new SupplierFrameworkAgreementDialogData(
            supplierCompanyId,
            editable,
            options,
        );

        const dialogRef: MatDialogRef<SupplierFrameworkAgreementDialogComponent, FrameworkAgreement> = this.dialog.open<
            SupplierFrameworkAgreementDialogComponent,
            FrameworkAgreement
        >(SupplierFrameworkAgreementDialogComponent, DialogOptions.MEDIUM(data));

        return dialogRef.afterClosed();
    }
}
